document.addEventListener('DOMContentLoaded', () => {
    initSpMenu()
    initLineupMovies()
    initGalleryModal()
    initScrollFadeIn()
});

// ============================================================
// SPメニューの開閉
// ============================================================
function initSpMenu() {
    const menu = document.querySelector('.p-sp-menu');
    const openButton = document.querySelector('.p-sp-menu__open');
    const closeButton = menu?.querySelector('.p-sp-menu__close');
    const menuLinks = menu?.querySelectorAll('.p-sp-menu__btn');
    const page = document.querySelector('.l-page');
    const spMediaQuery = window.matchMedia('(max-width: 767px)');

    // 必要な要素がないページでは処理しない
    if (!menu || !openButton || !closeButton || !menuLinks) {
        return;
    }

    const openMenu = () => {
        // PC表示時はSPメニューを開かない
        if (!spMediaQuery.matches) {
            return;
        }

        // メニュー表示中は背面スクロールを停止する
        document.body.classList.add('is-sp-menu-open');

        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        openButton.setAttribute('aria-expanded', 'true');

        // メニュー表示中は背面のコンテンツを操作できないようにする
        if (page) {
            page.inert = true;
        }
        openButton.inert = true;

        closeButton.focus({ preventScroll: true });
    };

    const closeMenu = () => {
        if (!menu.classList.contains('is-open')) {
            return;
        }

        // 背面を再び操作可能にしてから開くボタンへフォーカスを戻す
        if (page) {
            page.inert = false;
        }
        openButton.inert = false;
        openButton.focus({ preventScroll: true });

        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        openButton.setAttribute('aria-expanded', 'false');

        // 背面スクロールの停止だけを解除し、アンカー本来の移動を妨げない
        document.body.classList.remove('is-sp-menu-open');
    };

    openButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', closeMenu);

    // メニュー項目を選択したらメニューを閉じる
    menuLinks.forEach((menuLink) => {
        menuLink.addEventListener('click', closeMenu);
    });

    // Escキーでもメニューを閉じられるようにする
    menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeMenu();
        }
    });

    // メニュー表示中にPC幅へ変わった場合は閉じる
    spMediaQuery.addEventListener('change', (event) => {
        if (!event.matches) {
            closeMenu();
        }
    });
}

// ============================================================
// ラインナップ動画の再生・停止
// ============================================================
function initLineupMovies() {
    const movieGroups = document.querySelectorAll(
        '.p-lineup__movie_group'
    );

    movieGroups.forEach((movieGroup) => {
        const video = movieGroup.querySelector('video');
        const toggleButton = movieGroup.querySelector(
            '.p-lineup__movie_toggle'
        );

        // 動画または操作ボタンがない要素では処理しない
        if (!video || !toggleButton) {
            return;
        }

        // ラインナップ動画は初期状態から常に音声なしで再生する
        video.muted = true;
        video.defaultMuted = true;

        const updateButtonState = () => {
            const isPlaying = !video.paused && !video.ended;

            // 再生状態に合わせてボタン画像と読み上げ内容を切り替える
            toggleButton.setAttribute(
                'aria-pressed',
                String(isPlaying)
            );
            toggleButton.setAttribute(
                'aria-label',
                isPlaying ? '動画を停止' : '動画を再生'
            );
        };

        toggleButton.addEventListener('click', () => {
            if (video.paused) {
                video.play().catch((error) => {
                    console.error('動画を再生できませんでした。', error);
                    updateButtonState();
                });
            } else {
                video.pause();
            }
        });

        // JavaScript以外の要因で状態が変わった場合も表示を同期する
        video.addEventListener('play', updateButtonState);
        video.addEventListener('pause', updateButtonState);
        video.addEventListener('ended', updateButtonState);

        updateButtonState();
    });
}

// ============================================================
// ギャラリーのモーダル関連
// ============================================================
function initGalleryModal() {
    const galleryButtons = Array.from(
        document.querySelectorAll('.p-gallery__grid-item')
    );
    const galleryModal = document.querySelector('#gallery-modal');
    const modalImage = galleryModal?.querySelector('.p-gallery-modal__image');
    const prevButton = galleryModal?.querySelector(
        '.p-gallery-modal__button--prev'
    );
    const nextButton = galleryModal?.querySelector(
        '.p-gallery-modal__button--next'
    );
    const closeButton = galleryModal?.querySelector(
        '.p-gallery-modal__close'
    );
    const counter = galleryModal?.querySelector(
        '.p-gallery-modal__counter'
    );

    // 必要な要素が存在しないページでは処理しない
    if (
        galleryButtons.length === 0 ||
        !galleryModal ||
        !modalImage ||
        !prevButton ||
        !nextButton ||
        !closeButton
    ) {
        return;
    }

    let currentIndex = 0;
    let lastClickedButton = null;
    let scrollPosition = 0;

    const lockBodyScroll = () => {
        // 現在位置を保持したまま背面スクロールを停止する
        scrollPosition = window.scrollY;
        document.body.style.top = `-${scrollPosition}px`;
        document.body.classList.add('is-gallery-modal-open');
    };

    const unlockBodyScroll = () => {
        // スクロール停止前の位置へ戻す
        document.body.classList.remove('is-gallery-modal-open');
        document.body.style.top = '';
        window.scrollTo(0, scrollPosition);
    };

    const showImage = (index) => {
        // 最初と最後をつなぎ、画像を循環表示する
        currentIndex =
            (index + galleryButtons.length) % galleryButtons.length;

        const currentButton = galleryButtons[currentIndex];
        const thumbnail = currentButton.querySelector('img');
        const previewSrc = currentButton.dataset.gallerySrc;

        modalImage.src = previewSrc;
        modalImage.alt = thumbnail?.alt ?? '';

        if (counter) {
            counter.textContent =
                `${currentIndex + 1}枚目／${galleryButtons.length}枚中`;
        }
    };

    galleryButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
            lastClickedButton = button;
            showImage(index);

            // モーダル表示中は現在のスクロール位置で背面を固定する
            lockBodyScroll();
            galleryModal.showModal();
            // 閉じるボタンへフォーカスするが、画面はスクロールさせない
            closeButton.focus({ preventScroll: true });
        });
    });

    prevButton.addEventListener('click', () => {
        showImage(currentIndex - 1);
    });

    nextButton.addEventListener('click', () => {
        showImage(currentIndex + 1);
    });

    closeButton.addEventListener('click', () => {
        galleryModal.close();
    });

    // モーダル背景をタップした場合も閉じる
    galleryModal.addEventListener('click', (event) => {
        if (event.target === galleryModal) {
            galleryModal.close();
        }
    });

    // キーボードの左右キーでも画像を移動できるようにする
    galleryModal.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
            showImage(currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
            showImage(currentIndex + 1);
        }
    });

    galleryModal.addEventListener('close', () => {
        // 背面スクロールを解除して、モーダルを開く前の位置へ戻す
        unlockBodyScroll();

        // モーダルを閉じたら、最初にタップしたボタンへ戻す
        lastClickedButton?.focus({ preventScroll: true });
    });
}

// ============================================================
// スクロール表示時のフェード
// ============================================================
function initScrollFadeIn() {
    const targets = document.querySelectorAll('.js-scroll-fade');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
        targets.forEach(function (target) {
            target.classList.add('is-show');
        });
        return;
    }

    const observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-show');
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.2,
        rootMargin: '0px 0px -10% 0px',
    });

    targets.forEach(function (target) {
        observer.observe(target);
    });
}
